import { MethodPropertyModifySettingsForm } from "components/Forms/MethodPropertyModifySettingForm/MethodPropertyModifySettingsForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface ResponseConditionsSettingDrawerProps {
    name: number; // index of the condition in the responseConnectionPropertiesCheck array
    methodIndex: number; // index of the method in methods array
    responseHandlerIndex: number; // index of the response handler in responseHandlers array
}

export const ResponseConditionsSettingDrawer: FC<ResponseConditionsSettingDrawerProps> = ({
    name,
    methodIndex,
    responseHandlerIndex,
}) => {
    const { t } = usePaldockTranslation("drawers.response-conditions-setting");
    const drawerId = DrawerId.ResponseConditionsSetting;

    const conditionPath =
        `methods.${methodIndex}.requestConfig.responseHandlers.${responseHandlerIndex}.responseConnectionPropertiesCheck.${name}` as const;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name })} />}
            searchParamsToClean={[`${drawerId}-id`, `${drawerId}-methodIndex`, `${drawerId}-responseHandlerIndex`]}
        >
            <MethodPropertyModifySettingsForm propertyPath={conditionPath} />
        </Drawer>
    );
};
